import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import CaseSelectionImageViewModal from "./CaseSelectionImageViewModal";

const CaseSelectionModal = React.forwardRef((props, ref) => {
  const [isCardVisible1, setCardVisible1] = useState(true);
  const [viewImage, setViewImage] = useState(null);
  const [selectedCase, setSelectedCase] = useState(null);
  const [selectedId, setselectedId] = useState(null);
  const [getViewModalImage, setViewModalImage] = useState(false);

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  // Define case mappings for different building types
  const caseMappings = {
    CS: [
      {
        id: 1,
        key: "C1",
        label: "case01",
        img: "/assets/img/halleysblue/clear_span_roof_images/case_01_model.jpg",
      },
      {
        id: 2,
        key: "C2",
        label: "case02",
        img: "/assets/img/halleysblue/clear_span_roof_images/case_02_model.jpg",
      },
      {
        id: 3,
        key: "C3",
        label: "case03",
        img: "/assets/img/halleysblue/clear_span_roof_images/case_03_model.jpg",
      },
      {
        id: 4,
        key: "C4",
        label: "case04",
        img: "/assets/img/halleysblue/clear_span_roof_images/case_04_model.jpg",
      },
    ],
    MSB: [
      {
        id: 1,
        key: "M1",
        label: "case01",
        img: "/assets/img/halleysblue/double_slope_multi_span_Building/double_slope_multi_span_Building_1.jpg",
      },
      {
        id: 2,
        key: "M2",
        label: "case02",
        img: "/assets/img/halleysblue/double_slope_multi_span_Building/double_slope_multi_span_Building_2.jpg",
      },
      {
        id: 3,
        key: "M3",
        label: "case03",
        img: "/assets/img/halleysblue/double_slope_multi_span_Building/double_slope_multi_span_Building_3.jpg",
      },
      {
        id: 4,
        key: "M4",
        label: "case04",
        img: "/assets/img/halleysblue/double_slope_multi_span_Building/double_slope_multi_span_Building_4.jpg",
      },
    ]
    // Add more building types as needed
  };

  // Get the appropriate case mapping based on building type
  const getCaseMapping = () => {
    const buildingType = props.buildingType || "CS"; // Default to CS if not provided
    return caseMappings[buildingType] || caseMappings.CS;
  };

  // Get base template based on building type
  const getBaseTemplate = (caseKey, id, buildingType) => {
    const baseTemplates = {
      CS: {
        caseTypeCode: caseKey.toUpperCase(),
        caseTypeDiscription: `case0${id}`,
        width: "",
        clearHeightLSW: "",
        clearHeightRSW: "",
        eaveHeightLSW: "",
        eaveHeightRSW: "",
        ridgeHeight: "",
        leftSlope: "",
        rightSlope: "",
        ridgeDistanceLeft: "",
        ridgeDistanceRight: "",
        lswWallHeight: "",
        rswWallHeight: "",
        width1: "",
        width2: "",
        numberOfBays: "",
        partitionWall: "",
        staircase: "",
        roofMonitor: "",
        cageLadder: "",
      },
      MSB: {
        caseTypeCode: caseKey.toUpperCase(),
        caseTypeDiscription: `MSB Case 0${id}`,
        width: "",
        clearHeightLSW: "",
        clearHeightRSW: "",
        eaveHeightLSW: "",
        eaveHeightRSW: "",
        ridgeHeight: "",
        leftSlope: "",
        rightSlope: "",
        ridgeDistanceLeft: "",
        ridgeDistanceRight: "",
        lswWallHeight: "",
        rswWallHeight: "",
        width1: "",
        width2: "",
        numberOfBays: "",
        partitionWall: "",
        staircase: "",
        roofMonitor: "",
        cageLadder: "",
        // MSB specific fields
        mezzanineFloor: "",
        secondaryBeams: "",
        craneSystem: "",
        additionalColumns: "",
      }
    };
    
    return baseTemplates[buildingType] || baseTemplates.CS;
  };

  const handleCaseSelect = (caseKey, id) => {
    setSelectedCase(caseKey);
    setselectedId(id);
  };

  const handleSave = () => {
    if (!selectedCase) return;

    const buildingType = props.buildingType || "CS";
    const selectedCaseObject = getBaseTemplate(selectedCase, selectedId, buildingType);

    // Create case selection structure
    const caseKeys = getCaseMapping().map(item => item.key);
    const updatedCases = {};
    caseKeys.forEach(key => {
      updatedCases[key] = key === selectedCase;
    });

    const payload = {
      selectedCases: updatedCases,
      selectedCaseObject,
      buildingType: buildingType // Include building type in payload
    };

    if (props.onCaseSelect) {
      props.onCaseSelect(payload);
    }
    props.onHide();
  };

  const hideCaseSelectModal = () => {
    setViewModalImage(false);
    setViewImage(null);
  };

  const showCaseSelectModal = (img) => {
    setViewImage(img);
    setViewModalImage(true);
  };

  const currentCaseMapping = getCaseMapping();
  const buildingType = props.buildingType || "CS";

  return (
    <>
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        keyboard={false}
        size="xl"
        ref={ref}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Select Case - {buildingType} Building
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="">
          {/* accordion */}
          <div className="accordion mb-4" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <Row className="accordion-button">
                  <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                    <i
                      className={`bi ${
                        isCardVisible1 ? "bi-chevron-down" : "bi-chevron-right"
                      }`}
                      onClick={toggleCardVisibility1}
                    ></i>
                  </Col>
                  <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                    <span className="iconLogo">{buildingType}</span>
                  </Col>
                  <Col xs={8} md={9} lg={9}>
                    <span className="headerTitle">Case Selection</span>
                    <span className="subHeaderTitle">
                      {buildingType === "CS" 
                        ? "Clear Span Building Cases" 
                        : "Multi-Span Building Cases"}
                    </span>
                  </Col>
                </Row>
              </h2>

              <div
                className={`accordion-collapse collapse show ${
                  isCardVisible1 ? "visible" : ""
                }`}
              >
                <div className="accordion-body">
                  <Row className="pt-2 pb-4 d-flex align-items-center">
                    <Col xs={12} md={12} lg={12}>
                      <div className="d-flex flex-row flex-wrap gap-5 p-4 justify-center">
                        {currentCaseMapping.map((item) => (
                          <div
                            key={item.key}
                            className="text-center cursor-pointer position-relative"
                            style={{ width: "450px" }}
                            onClick={() => handleCaseSelect(item.key, item.id)}
                          >
                            {/* Image */}
                            <img
                              src={item.img}
                              alt={item.label}
                              style={{
                                width: "100%",
                                height: "400px",
                                objectFit: "contain",
                                borderRadius: "20px",
                                cursor: "pointer",
                                border:
                                  selectedCase === item.key
                                    ? "8px solid #0d6efd"
                                    : "4px solid #ccc",
                                boxShadow:
                                  selectedCase === item.key
                                    ? "0 6px 20px rgba(13, 110, 253, 0.6)"
                                    : "0 4px 12px rgba(0,0,0,0.3)",
                                transition: "all 0.3s ease",
                              }}
                              onClick={() => handleCaseSelect(item.key, item.id)}
                            />

                            {/* ✅ Tick overlay */}
                            {selectedCase === item.key && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "15px",
                                  right: "15px",
                                  background: "#0d6efd",
                                  color: "white",
                                  borderRadius: "50%",
                                  width: "50px",
                                  height: "50px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontSize: "26px",
                                  fontWeight: "bold",
                                  boxShadow: "0 3px 10px rgba(0,0,0,0.4)",
                                }}
                              >
                                ✓
                              </div>
                            )}

                            {/* Label */}
                            <div
                              style={{
                                marginTop: "15px",
                                fontSize: "24px",
                                fontWeight: "700",
                              }}
                            >
                              {item.label}
                              <span
                                className="fw-bold ms-2"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  showCaseSelectModal(item.img);
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <i className="bi bi-eye"></i>
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-4">
            <Row className="justify-end">
              <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
                <button
                  type="button"
                  onClick={() => props.onHide()}
                  className="btn btn-danger mt-4 w-full justify-center rounded-md"
                >
                  Cancel
                </button>
              </Col>
              <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
                <button
                  onClick={handleSave}
                  disabled={!selectedCase}
                  className="btn btn-primary mt-4 w-full justify-center rounded-md"
                >
                  Save
                </button>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>
      <CaseSelectionImageViewModal
        show={getViewModalImage}
        onHide={() => hideCaseSelectModal()}
        viewImage={viewImage}
      />
    </>
  );
});

export default CaseSelectionModal;